import { formatCompact } from "@/lib/format";

interface FollowersColumnCellProps {
  followers: number | undefined;
}

export default function FollowersColumnCell({
  followers,
}: FollowersColumnCellProps) {
  return (
    <div className="text-muted-foreground font-mono">{formatCompact(followers)}</div>
  );
}
